import axios from 'axios'
import mutations from '@/store/mutation-types'
import actions from '@/store/action-types'

export default {
  state: {
    shareId: null
  },
  mutations: {
    [ mutations.update.SHARED_CONTENTS ] (state, payload) {
      state.shareId = payload.uid
    }
  },
  actions: {
    [ actions.post.SHARED_CONTENTS ] ({ commit, rootState }, payload) {
      return axios.post(`${rootState.SHARE_API_BASE_URL}/shares`, {
        ...rootState.urlParams,
        ...payload
      }).then(({ data }) => {
        commit(mutations.update.SHARED_CONTENTS, data)
      }).catch(error => {
        console.log(`${actions.post.SHARED_CONTENTS}: ${error}`)
      })
    },
    [ actions.fetch.SHARED_CONTENTS ] ({ commit, rootState }) {
      return axios.get(`${rootState.SHARE_API_BASE_URL}/shares/${rootState.urlParams.shareId}`, {
        params: rootState.urlParams
      }).then(({ data }) => {
        // 此处的 Mutations 调用了 overview store 下的方法
        commit(mutations.update.USER_SUMMRAY, {
          nick: data.nick,
          avatar: data.avatar,
          totalDuration: data.total_duration,
          donationObjects: data.donation_objects
        })
      }).catch(error => {
        console.log(`${actions.fetch.SHARED_CONTENTS}: ${error}`)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/share.js